import React from 'react';
import ShareRedirect from './share-redirect';

const ShareFreelancer = () => <ShareRedirect shareType="freelancer" />;

export default ShareFreelancer;
